<div class="row">
    <div class="col-md-12">
        <app-util-visitor-parts-observation-list-filter
                                            [selfVisitor]="selfVisitor"
                                            (filterEvent)="filterVisitorObservations($event)"></app-util-visitor-parts-observation-list-filter>
    </div>
</div>
<div class="row mt-5">
    <div class="col-md-12 align-items-center justify-content-space-between">
        <h5 class="title mb-3">
            <ng-container *ngIf="selfVisitor">
                {{ 'VISITORS_MEDICAL.VISITOR_OBSERVATIONS' | translate }}
            </ng-container>
            <ng-container *ngIf="!selfVisitor">
                {{ 'VISITORS_MEDICAL.VISITORS_OBSERVATIONS' | translate }}
            </ng-container>
        </h5>
        <button type="button"
                class="btn btn-primary btn-fill"
                (click)="utilVisitorPartsObservationModalsAdd.openModal(visitor?.id)"
                *ngxPermissionsOnly="'cudVisitorObservation'">
            <i class="fa fa-plus"></i> {{ 'VISITORS_MEDICAL.ADD_OBSERVATION' | translate }}
        </button>
    </div>
</div>
<div class="row mt-3">
    <div class="col-md-12">
        <ng-container *ngIf="!isLoading">
            <ng-container *ngIf="hasData?.visitorObservations">
                <div class="overflow-auto pb-3">
                    <table class="table table-condensend table-striped">
                        <thead>
                            <tr>
                                <th class="p-3 text-center-important">#</th>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.DATE' | translate }}</th>
                                <ng-container *ngIf="!selfVisitor">
                                    <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.VISITOR' | translate }}</th>
                                </ng-container>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.OBSERVATIONS' | translate }}</th>
                                <th class="p-3 text-center-important text-right" *ngxPermissionsOnly="'cudVisitorObservation'">{{ 'SHARED.ACTIONS' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let visitorObservation of visitorObservations?.data; let i = index">
                                <td class="p-3 text-center-important">{{ i + 1 }}</td>
                                <td class="p-3 text-center-important">{{ visitorObservation?.date | localizedDate | ifEmpty: '-' }}</td>
                                <ng-container *ngIf="!selfVisitor">
                                    <td class="p-3 text-center-important">
                                        <a [routerLink]="['/visitor', visitorObservation?.vId, 'infirmary', 'observations']"
                                            class="text-primary">
                                            {{ visitorObservation?.showName }}
                                        </a>
                                    </td>
                                </ng-container>
                                <td class="p-3 text-center-important">
                                    {{ visitorObservation?.observations | ifEmpty: '-' }}
                                </td>
                                <td class="p-3 text-center-important text-right td-actions" *ngxPermissionsOnly="'cudVisitorObservation'">
                                    <button type="button"
                                            class="btn btn-success btn-simple p-0"
                                            title="{{ 'VISITORS_MEDICAL.EDIT_OBSERVATION' | translate }}"
                                            (click)="utilVisitorPartsObservationModalsAdd.openModal(visitor?.id, visitorObservation)"
                                            appTooltip>
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button type="button"
                                            class="btn btn-danger btn-simple ml-3 p-0"
                                            title="{{ 'VISITORS_MEDICAL.DELETE_OBSERVATION' | translate }}"
                                            (click)="delete(visitorObservation)"
                                            appTooltip>
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="align-items-center justify-content-center" *ngIf="visitorObservations?.last_page > 1">
                        <app-pagination [data]="visitorObservations" (switchPage)="switchPage($event)"></app-pagination>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!hasData?.visitorObservations">
                <p>
                    <ng-container *ngIf="selfVisitor">
                        {{ 'VISITORS_MEDICAL.NO_VISITOR_OBSERVATION_FOUND' | translate }}
                    </ng-container>
                    <ng-container *ngIf="!selfVisitor">
                        {{ 'VISITORS_MEDICAL.NO_VISITORS_OBSERVATION_FOUND' | translate }}
                    </ng-container>
                </p>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="isLoading">
            <p>
                <app-loading-spinner></app-loading-spinner>
            </p>
        </ng-container>
    </div>
</div>
<app-util-visitor-parts-observation-modals-add (addObservationEvent)="addObservation()" #utilVisitorPartsObservationModalsAdd></app-util-visitor-parts-observation-modals-add>